import { Button, FormGroup } from '@bepro-travel/fe.ui';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faHeadphonesSimple } from '@fortawesome/free-solid-svg-icons';
import { contactUsValidation as validation } from '../constants';
import { showError, showSuccess, validate } from '@bepro-travel/fe.utils';
import { useRecaptcha } from '@bepro-travel/fe.hooks';
import { ContactUsModel } from '../types';
import { sendContactUs } from '../service';

interface ContactUsFormProps {
  order: number;
}

const ContactUsForm: FC<ContactUsFormProps> = ({ order }) => {
  const { t } = useTranslation();

  const translate = t as (key: string) => string;
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [model, setModel] = useState(new ContactUsModel());
  const { handleRecapcha } = useRecaptcha();
  // const options = useRef([...Array(5)].map((_, i) => ({ value: i + 1 + '', label: i + 1 + '' })));

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setIsLoading(true);
    setIsSubmitted(true);
    const isValid = validate(validation, model);

    if (isValid) {
      const token = await handleRecapcha();

      if (token) {
        const res = await sendContactUs({ ...model, recaptchaToken: token });
        if (res?.hasErrors) {
          showError(translate('something_went_wrong'));
        } else {
          setModel(new ContactUsModel());
          setIsSubmitted(false);
          showSuccess(translate('login.contact_us_success'));
        }
      }
    }
    setIsLoading(false);
  };

  return (
    <form className="contact_us default-shadow flex-row" onSubmit={onSubmit} style={{ order }}>
      <div className="title col-12">{translate('login.contact_us')}</div>
      <FormGroup
        className="col-12 col-md-6 mb-20"
        label={translate('login.full_name')}
        value={model.firstName}
        onChange={(firstName) => setModel({ ...model, firstName })}
        movablePlaceholder={translate('login.full_name')}
        validation={validation.firstName}
        isSubmitted={isSubmitted}
      />
      <FormGroup
        className="col-12 col-md-6 mb-20"
        label={translate('passenger.phone')}
        value={model.phone}
        onChange={(phone) => setModel({ ...model, phone })}
        movablePlaceholder={translate('passenger.phone')}
        validation={validation.phone}
        isSubmitted={isSubmitted}
      />
      <FormGroup
        className="col-12 col-md-6 mb-20"
        label={translate('passenger.email')}
        value={model.email}
        onChange={(email) => setModel({ ...model, email })}
        movablePlaceholder={translate('passenger.email')}
        validation={validation.email}
        isSubmitted={isSubmitted}
      />
      {/* <div className="col-12 col-md-6 mb-20">
        <SelectCustom
          options={options.current}
          movablePlaceholder={translate('login.select_number')}
          value={model.paxes}
          onChange={(paxes) => setModel({ ...model, paxes })}
          invalid={isSubmitted && !model.paxes}
        />
      </div> */}
      <div className="col-12">
        <div className={'form-group' + (isSubmitted && !model.message ? ' is-invalid' : '')}>
          <textarea
            className={`form-control`}
            value={model.message}
            onChange={(e) => setModel({ ...model, message: e.target.value })}
            style={{ height: '150px', resize: 'none' }}
          />
          {isSubmitted && !model.message && (
            <div className="form-invalid-text">{translate('validation.required')}</div>
          )}
        </div>
      </div>
      <div className="col-12">
        <Button
          title={translate('login.get_back')}
          icon={faHeadphonesSimple}
          iconclassname="mr-5"
          disabled={isLoading}
        />
      </div>
    </form>
  );
};

export default ContactUsForm;
